export default __webpack_public_path__ + "static/media/dispatch.e7cc8b1a.png";